(function () {
  function formatShortDate(date) {
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'short' });
    return day + ' ' + month;
  }

  function formatDeliveryLine(start, end) {
    return 'Order today and receive by ' + formatShortDate(start) + ' \u2013 ' + formatShortDate(end);
  }

  function addDays(date, days) {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  }

  function updateDeliveryDates(root) {
    const lineEl = root.querySelector('[data-ff-delivery-line]');
    if (!lineEl) return;

    const today = new Date();
    today.setHours(12, 0, 0, 0);

    const deliveryStart = addDays(today, 3);
    const deliveryEnd = addDays(today, 5);

    lineEl.textContent = formatDeliveryLine(deliveryStart, deliveryEnd);
  }

  function initDelivery(root) {
    if (!root || root.dataset.ffDeliveryInit === 'true') return;
    root.dataset.ffDeliveryInit = 'true';
    updateDeliveryDates(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ff-product-delivery').forEach(initDelivery);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
